// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"28":"66289090","407":"bdaf3960","545":"809135df","607":"664c29b5","687":"01b732bb","717":"46e56e5a","915":"93cb842e"}[chunkId] + ".css";
};